var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAlienBlue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 266,
    height: 345,
    viewBox: "0 0 266 345",
    fill: "none",
    id: "svg556",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4666_72280)",
    id: "g535",
    transform: "translate(6.4999082,5.4864042)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 238.975,272.99 C 237.84,250.227 229.401,259.636 209.071,255.278 204.406,254.279 197.45,254.3 197.443,254.286 181.75,213.882 224.137,196.005 221.041,128.48 219.657,98.4762 215.912,62.4591 200.397,41.5436 182.028,16.7761 152.959,4 122.955,4 95.0632,4 66.2653,16.077 48.0962,37.8628 30.2054,59.3132 22.7295,90.2298 22.7295,122.773 c 0,87.043 39.8121,94.604 30.1533,126.513 -0.107,0.356 -5.3715,2.81 -8.389,4.522 -13.3611,7.59 -35.14678,-7.019 -29.6112,25.902 1.9903,11.863 21.907,16.428 37.2512,10.843 7.697,-2.804 16.7067,-10.379 16.4499,-9.06 -3.952,20.509 10.1438,28.534 21.4076,28.534 11.2637,0 21.4217,-4.993 19.3817,-28.534 -0.014,-0.128 1.598,0.2 1.598,0.45 0,15.508 5.871,25.944 23.705,25.944 15.972,0 21.785,-10.193 19.453,-26.394 -0.107,-0.756 5.878,23.669 22.363,22.385 8.853,-0.692 21.386,-7.447 18.012,-16.977 -4.109,-11.614 0.642,-0.835 1.07,-0.507 4.345,3.289 10.158,5.379 18.333,5.379 15.623,-0.007 25.667,-6.884 25.068,-18.783 z",
    fill: "#c0d3f8",
    stroke: "#000000",
    strokeWidth: 7.13351,
    strokeMiterlimit: 10,
    id: "path521"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 155.756,96.7727 c 23.683,-4.6012 12.969,-1.3768 34.947,-14.9875",
    stroke: "#232e2e",
    strokeWidth: 7.13351,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    id: "path523"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 50.5371,80 c 15.4155,11.0569 17.955,8.4746 39.3556,15.3442",
    stroke: "#232e2e",
    strokeWidth: 7.13351,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    id: "path525"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 176.349,136.283 c 7.926,0 14.352,-6.426 14.352,-14.352 0,-7.927 -6.426,-14.353 -14.352,-14.353 -7.927,0 -14.353,6.426 -14.353,14.353 0,7.926 6.426,14.352 14.353,14.352 z",
    fill: "#fefefc",
    stroke: "#232e2e",
    strokeWidth: 7.13351,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    id: "path527"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 68.9913,135.213 c 7.9267,0 14.3526,-6.426 14.3526,-14.353 0,-7.926 -6.4259,-14.352 -14.3526,-14.352 -7.9267,0 -14.3526,6.426 -14.3526,14.352 0,7.927 6.4259,14.353 14.3526,14.353 z",
    fill: "#fefefc",
    stroke: "#232e2e",
    strokeWidth: 7.13351,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    id: "path529"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 159.543,171.536 c -2.168,-7.547 9.58,-12.534 18.647,-13.818 11.128,-1.569 18.526,0.478 19.075,6.463 0.464,5.022 -2.561,13.09 -18.647,14.888 -9.109,1.013 -17.341,-1.484 -19.075,-7.533 z",
    fill: "#f6fbd5",
    id: "path531"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 43.9591,164.374 c 1.12,-7.205 11.8416,-8.268 21.3363,-6.791 9.4876,1.477 17.1418,5.4 16.0219,12.598 -1.12,7.205 -12.2554,10.072 -20.8655,8.667 -11.8345,-2.311 -17.6127,-7.269 -16.4927,-14.474 z",
    fill: "#f6fbd5",
    id: "path533"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs554"
  }, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4666_72280",
    x: 0.43359399,
    y: 0.43359399,
    width: 252.133,
    height: 333.16,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix",
    id: "feFlood537"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha",
    id: "feColorMatrix539"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10,
    id: "feOffset541"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    id: "feGaussianBlur543"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out",
    id: "feComposite545"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0",
    id: "feColorMatrix547"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4666_72280",
    id: "feBlend549"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4666_72280",
    result: "shape",
    id: "feBlend551"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlienBlue);
export default __webpack_public_path__ + "static/media/alien_blue.50b3b7bade5ae2f128a1e2cc71914988.svg";
export { ForwardRef as ReactComponent };